<div class="container">

  <!-- ======================= MOBILE VIEW ======================= -->
  @if (isMobile$ | async) {
  <div class="mobile">
    <!-- Search and Filter Section (Hidden on Desktop) -->
    <div class="search-filter">
      <div class="search-container">
        <div class="search-input">
          <input
            type="text"
            pInputText
            placeholder="Search restriction"
            [formControl]="searchTermControl"
          />
        </div>
        <div class="button-group">
          <button class="sort-btn" (click)="toggleSortOrder()">
            <span class="material-symbols-outlined">sort_by_alpha</span>
          </button>
        </div>
      </div>
    </div>
    <!-- Mobile Restriction Cards [ngClass]="{'selected-card': item.selected}"-->
    @for (restriction of filteredAndSortedRestrictions$ | async; track restriction.displayName) {
      <div class="restriction-card">
        <p-card class="custom-card">
          <div class="card-content">
            <!-- Right-aligned content: Conditional Download Icon and Version -->
            <div class="left-content">
              <div class="card-title"><strong></strong> {{ restriction.displayName }} : {{ restriction.restrictionName }}</div>
              <div class="subheader"><i class="pi pi-user"></i> {{ restriction.responsible }}</div>
              <div class="subheader"><i class="date-range"></i>Created: {{ restriction.dateCreated | date:'yyyy-MM-dd HH:mm'}}</div>
              <div class="subheader"><i class="date-range"></i>Updated: {{ restriction.dateUpdated | date:'yyyy-MM-dd HH:mm'}}</div>
              <div class="subheader"><i class="date-range"></i>Valid to: {{ restriction.validTo | date:'yyyy-MM-dd'}}</div>
              <div class="subheader">BAN:
                @if (restriction.banPublicRoad) { <span>Public Road</span> }
                @if (restriction.banPublicRoad && restriction.banTestTrack) { <span>, </span> }
                @if (restriction.banTestTrack) { <span>Test Track</span> }
              </div>
            </div>
          </div>
          <!-- TODO: Add user roles so that not all users can edit and delete from their phone -->
          <!-- <div class="button-container">
            <div class="grow-button">
              <p-button 
                label="Edit"
                icon="pi pi-pencil"
                iconPos="left" 
                (onClick)="onEdit(restriction)"
              ></p-button>
            </div>
            <div class="grow-button">
              <p-button 
                label="Delete"
                icon="pi pi-trash"
                iconPos="left" 
                (onClick)="confirmDelete(restriction)"
              ></p-button>
            </div>
          </div> -->
        </p-card>
      </div>
    }
  </div><!-- .mobile -->
  } @else {
  <!-- ======================= DESKTOP VIEW ======================= -->
  <div class="desktop">
    @if (restrictions$ | async; as restrictions) {
      <div class="table-card">
        <p-table
          #restrictionTable
          [value]="restrictions || []"
          [paginator]="true"
          [rows]="10"
          [first]="first"
          [showCurrentPageReport]="true"
          [tableStyle]="{ 'min-width': '50rem' }"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          (onPage)="pageChange($event)"
          [rowsPerPageOptions]="[10, 25, 50]"
          [globalFilterFields]="['displayName', 'restrictionName' ,'responsible']"
          [customSort]="true"
          [sortField]="'dateUpdated'"
          [sortOrder]="-1"
          (sortFunction)="onSort($event)"
            >
          <ng-template #caption>
            <div class="flex justify-content-end">
              <p-iconfield iconPosition="left">
                <p-inputicon>
                  <i class="pi pi-search"></i>
                </p-inputicon>
                <input
                  pInputText
                  type="text"
                  (input)="onGlobalFilter($event)"
                  placeholder="Search keyword"
                />
              </p-iconfield>
            </div>
          </ng-template>

          <!-- Table Header -->
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="displayName">Restriction ID <p-sortIcon field="displayName" /></th>
              <th pSortableColumn="restrictionName">Restriction Name <p-sortIcon field="restrictionName" /></th>
              <th pSortableColumn="dateCreated">Created Date <p-sortIcon field="dateCreated" /></th>
              <th pSortableColumn="dateUpdated">Updated Date <p-sortIcon field="dateUpdated" /></th>
              <th pSortableColumn="validTo">Valid To <p-sortIcon field="validTo" /></th>
              <th pSortableColumn="responsible">Responsible <p-sortIcon field="responsible" /></th>
              <th pSortableColumn="banPublicRoad">BAN <p-sortIcon field="banPublicRoad" /></th>
              @if (isAdmin$ | async) { <th>Actions</th> }
            </tr>
          </ng-template>
          <!-- Table Body -->
          <ng-template pTemplate="body" let-restriction>
            <tr>
              <td>
                @if (isAdmin$ | async) {
                  <a class="restriction-id-link" (click)="onEdit(restriction)">{{ restriction.displayName }}</a>
                } @else {
                  {{ restriction.displayName }}
                }
              </td>
              <td>{{ restriction.restrictionName }}</td>
              <td>{{ restriction.dateCreated | date:'yyyy-MM-dd HH:mm' }}</td>
              <td>{{ restriction.dateUpdated | date:'yyyy-MM-dd HH:mm' }}</td>
              <td>{{ restriction.validTo | date:'yyyy-MM-dd' }}</td>
              <td>{{ restriction.responsible }}</td>
              <td>
                @if (restriction.banPublicRoad) { Public Road }
                @if (restriction.banPublicRoad && restriction.banTestTrack) { , }
                @if (restriction.banTestTrack) { Test Track }
              </td>
              @if (isAdmin$ | async) {
                <td>
                  <div class="actions">
                    <p-button
                      icon="pi pi-pencil"
                      styleClass="p-button-text p-button-sm"
                      (onClick)="onEdit(restriction)"
                      aria-label="Edit"
                    ></p-button>
                    <p-button
                      icon="pi pi-trash"
                      styleClass="p-button-text p-button-sm"
                      (onClick)="confirmDelete(restriction)"
                      aria-label="Delete"
                    ></p-button>
                  </div>
                </td>
              }
            </tr>
          </ng-template>
        </p-table>
      </div>
    }
  </div><!-- .desktop -->
  }

  <!-- ======================= MOBILE AND DESKTOP VIEW ======================= -->
  <app-restriction-dialog
    [(visible)]="showDialog"
    (onSave)="handleSave($event)"
    [editRestriction]="selectedRestriction"
    (visibleChange)="onDialogVisibleChange($event)" 
  ></app-restriction-dialog>
  <p-dialog
    [(visible)]="showDeleteConfirmDialog"
    [modal]="true"
    [closable]="false"
    [style]="{ width: '450px' }"
    class="custom-confirm-dialog"
  >
    <div class="dialog-content">
      <i class="pi pi-exclamation-triangle warning-icon"></i>
      <span class="dialog-message">
        Are you sure you want to delete this restriction?
      </span>
    </div>
    <ng-template pTemplate="footer">
      <div class="dialog-footer">
        <button
          pButton
          type="button"
          label="No"
          class="no-button"
          (click)="cancelDelete()"
        ></button>
        <button
          pButton
          type="button"
          label="Yes"
          class="yes-button"
          (click)="deleteConfirmed()"
        ></button>
      </div>
    </ng-template>
  </p-dialog>
</div><!-- .container -->